import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from '@mui/material/IconButton';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { NavLink } from "react-router-dom";
import UploadDialog from "./Dialogues/UploadDialog";
// import ExportDataDialog from "./Dialogues/ExportDataDialog";
import swaasaLogo from "../Assets/images/Swaasa.png";
import apolloLogo from '../Assets/images/apollo.png'
import TuneIcon from '@mui/icons-material/Tune';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MasksIcon from '@mui/icons-material/Masks';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import axios from '../axios';
import { createTheme, ThemeProvider, } from "@mui/material";
import '../Assets/styles/newStyles/Navbar.css'
import { css } from "@emotion/react";
import PropTypes from 'prop-types';
import { useLocation, useHistory } from "react-router-dom";
import profileIcon from '../Assets/images/profile-icon.svg';
import logoutButton from '../Assets/images/exit.png'
import PaymentsIcon from '@mui/icons-material/Payments';
 

const theme = createTheme({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:selected": {
            backgroundColor: "#ff7d00",
            color: "red",
            fontWeight: "bold"
          },
          "&:hover": {
            // backgroundColor: "#ffdcb7",
            // cursor: 'pointer'
          }
        }
      }
    }
  }
});


// const useStyles = makeStyles({
//   root: {
//     "& .Mui-selected": {
//       backgroundColor: "pink", // Change background color when selected
//       color: "red",
//       fontWeight: "bold"
//     },
//     "& .Mui-selected:hover": {
//       backgroundColor: "tomato"
//     }
//   }
// });
const useStyles = makeStyles({
  root: {
    // Your existing styles...
  },
  selected: {
    backgroundColor: "pink", 
    color: "red",
    fontWeight: "bold"
  }
});

const BiggerListItemIcon = withStyles({
  root: {
    "& .MuiSvgIcon-root": { fontSize: "3rem" },
  },
})(ListItemIcon);

function AdminNavbar({onToggleCollapseAdmin}) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [open, setOpen] = useState(false);
  // const [openExport, setOpenExport] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  // const drawerWidth = 240;
  const [drawerWidth, setDrawerWidth] = useState(window.innerWidth >= 768 ? 240 : 180);
  const [collapsed, setCollapsed] = useState(false);
  const [prevSelectedItemIndex, setPrevSelectedItemIndex] = useState(0);
  const [doctorName, setDoctorName] = useState(localStorage.name);
  const [role, setRole] = useState(localStorage.role);

  const setPrevIndex = () => {
    setPrevSelectedItemIndex(selectedItemIndex);
  };

  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth >= 769 ? 240 : 180);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const storedIndex = localStorage.getItem("selectedItemIndex");
    if (storedIndex !== null) {
      setSelectedItemIndex(parseInt(storedIndex));
    }
  }, []);

  useEffect(() => {
    // Define a map of routes to their corresponding index in the Navbar
    const routeToIndexMap = {
      "/admindashboard": 0,
      "/doctorslist": 1,
      "/patients": 2,
      "/assessments": 3,
      "/adminsettings": 4,
      "/export":5,
      "/payments": 7, 
      "/drl-orgs":8,
      "/drl-doctors":9
    };

    // Get the index of the current route from the map
    const index = routeToIndexMap[location.pathname];

    // Check specific conditions for certain routes
    if (location.pathname.startsWith("/patient")) {
      setSelectedItemIndex(2);
    } else if (location.pathname.startsWith("/assessments")) {
      setSelectedItemIndex(3);
    } else if (location.pathname.startsWith("/doctorslist")) {
      setSelectedItemIndex(1);
    // } else if (location.pathname.startsWith("/agentslist")) {
    //   setSelectedItemIndex(2);
    } else if (location.pathname.startsWith("/doctorDetails")) {
      setSelectedItemIndex(1);
    } 
    else if (location.pathname.startsWith("/export")) {
      setSelectedItemIndex(5);
    }
    else if (location.pathname.startsWith("/adminsettings")) {
      setSelectedItemIndex(4);
    } else if (location.pathname.startsWith("/payments")) { // Added condition
      setSelectedItemIndex(7);
      
    } 
    else if (location.pathname.startsWith("/drl-orgs")) { // Added condition
      setSelectedItemIndex(8);
    }
    else if (location.pathname.startsWith("/drl-doctors")) { // Added condition
      setSelectedItemIndex(9);
      
    }else if (index !== undefined) {
      setSelectedItemIndex(index);
    } else {
      setSelectedItemIndex(0);
    }

  }, [location.pathname]);

  // Save selected item index to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("selectedItemIndex", selectedItemIndex);
  }, [selectedItemIndex]);

  
  const styles = useStyles();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const icons = [
    <HomeIcon />,
    <LocalHospitalIcon />,
    // <MasksIcon />,
    <PersonIcon />,
    <AssessmentIcon />,
    <TuneIcon />,
    <CloudDownloadIcon />,
    <DriveFolderUploadIcon />,
    (localStorage.patientPayment==='true') && <PaymentsIcon/>,
    (localStorage.patientPayment==='true') && <AddBusinessIcon/>,
    (localStorage.patientPayment==='true') && <LocalHospitalIcon/>
    
  ];

  const handleExport = () => {
    // setOpenExport(true);
    setPrevIndex();
  }
  // const handleCloseExport = () => {
  //   setOpenExport(false);
  //   setSelectedItemIndex(prevSelectedItemIndex);
  // }
  // const exportData = () => {
  //   axios
  //     .get(`/export-data/${localStorage.adminId}`, {
  //       headers: { accessToken: localStorage.accessToken },
  //       responseType: "blob",
  //     })
  //     .then((response) => {

  //       var today = new Date();
  //       var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
  //       const fileName = localStorage.doctorId + "-(" + date +').xlsx'
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  // };
  // const exportApolloData = () => {
  //   axios
  //     .get(`/export-executive-data?doctorId=${encodeURIComponent(localStorage.doctorId)}`, {
  //       headers: { accessToken: localStorage.accessToken },
  //       responseType: "blob",
  //     })
  //     .then((response) => {
  //       var today = new Date();
  //       var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
  //       const fileName = localStorage.doctorId + "-(" + date +').xlsx'
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  // };

  const handleUpload = () => {
    setOpen(true);
    setPrevIndex();
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItemIndex(prevSelectedItemIndex);
  }

  const handleListItemClick = (index, to) => {
    setSelectedItemIndex(index);
    if (to) {
      history.push(to);
    }
  };
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    const width = collapsed ? (window.innerWidth >= 769 ? 240 : 180) : 90;
    setDrawerWidth(width);
    onToggleCollapseAdmin(!collapsed);
  };

  const history = useHistory(); 

  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
    history.push("/"); // Redirect to the login page
  }

  const drawer = (
    <ThemeProvider theme={theme}>
        <img className={localStorage.adminId === "admin@apollo.com" ? "apollo-logo-img": "nav-logo-img"} src={localStorage.adminId === "admin@apollo.com" ? apolloLogo : swaasaLogo} alt="logo"
          style={{ width: collapsed ? '66px' : '', height: collapsed ? '20px' : '', margin: collapsed ? '20px 0 20px 2px' : '' }}
        />
      <Divider />
      <div className="collapse-container" onClick={toggleCollapse}>
        {!collapsed ? 
          <p className="collapse-text">Collapse</p>
          :
          // <p className="collapse-text">Expand</p>
          ""
        }
        {collapsed ? 
          <KeyboardDoubleArrowRightIcon sx={{color: "#ff7208"}} /> : <KeyboardDoubleArrowLeftIcon sx={{color: "#ff7208"}} />
        }
      </div>
      <List className={styles.root} sx={{height:'56vh',overflowY: "auto"}}>
      {[
        { text: "Home", to: "/admindashboard", tooltip: "Go to Home" },
        (localStorage.patientPayment !== 'true') && { text: "Doctors / Health Workers", to: "/doctorslist", tooltip: "Doctors" },
        (localStorage.patientPayment!=='true') && { text: "Patients", to: "/patients", tooltip: "View Patients" },
        (localStorage.patientPayment!== "true") && { text: "Assessments", to: "/assessments", tooltip: "View Assessments" },
        (localStorage.patientPayment!=='true') && { text: "Configurations", to: "/adminsettings", tooltip: "Configurations" },
        (localStorage.export_data === "true") && { text: "Export", to:"/export", tooltip: "Export Data" },
        (localStorage.bulkupload === "true") && { text: "Upload", onClick: handleUpload, tooltip: "Upload Data" },
        (localStorage.patientPayment==='true') && { text: "Accounts", to: "/payments", tooltip: "View Payments" },
        (localStorage.patientPayment==='true') && { text: "Drl Orgs", to: "/drl-orgs", tooltip: "View DRL Orgs" },
        (localStorage.patientPayment==='true') && { text: "Drl Doctors", to: "/drl-doctors", tooltip: "View DRL Doctors" },
      ].map(
        (item, index) =>
          item && (
            <ListItem
              key={item.text}
              onClick={() => handleListItemClick(index, item.to)}
              classes={{ selected: styles.selected }}
              sx={{
                backgroundColor: selectedItemIndex === index ? "#ffdcb7" : "inherit",
                fontWeight: selectedItemIndex === index ? "bold" : "normal",
                padding: "0px",
                fontSize: "6px",
              }}
            >
              <ListItemButton onClick={item.onClick ? () => item.onClick(index) : null}>
                <ListItemIcon sx={{ minWidth: "30px", borderRadius: "4px" }}>
                  <BiggerListItemIcon>{icons[index]}</BiggerListItemIcon>
                </ListItemIcon>
                {!collapsed && <ListItemText primary={item.text} />}
              </ListItemButton>
            </ListItem>
          ))}
    </List>
    {!collapsed &&(
        <div className="navbar-footer" >
          <div className="profile-container" style={{margin: '0 0 5px 0'}}>
            <div className="logout-container">
              <img className="profile-icon-img" src={profileIcon} alt="" />
            </div>
            <div className="profile-names">
              <p className='doctor-name' style={{textTransform:'capitalize',maxWidth:'100%'}} >{doctorName}</p>
              <p className='topbar-role' style={{textTransform:'capitalize'}} >{role}</p>
            </div>
            <img onClick={handleLogout} className="logout-btn" src={logoutButton} alt="" />
          </div>
          <p className="powered-by">Powered by</p>
          <p className="swaasa-ai">Swaasa.AI</p>
          <p className="swaasa-version">
            Swaasa AI Platform {process.env.REACT_APP_SWAASA_VERSION}
          </p>
          <p className="swaasa-version">
            Dashboard {process.env.REACT_APP_VERSION}
          </p>
        </div>
      )}
    </ThemeProvider>
  );

  return (
    <>
    <ThemeProvider theme={theme}>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: 'none' } }}
      >
        <MenuIcon sx={{ color: "orange", fontSize: 32, marginLeft: "20px" }} />
        <span style={{ marginLeft: "10px" }}>Menu</span>
      </IconButton>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              fontSize: "2.5rem",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      {/* <ExportDataDialog
        openExport={openExport}
        handleCloseExport = {(data) => handleCloseExport()}
        handleExport={exportData}
        handleExportApollo={exportApolloData}
      /> */}
      <UploadDialog open={open}
        handleClose={(data) =>
        handleClose()
      } ></UploadDialog>
    </ThemeProvider>
    </>
  );
}

AdminNavbar.propTypes = {
  onToggleCollapseAdmin: PropTypes.func.isRequired,
};

export default AdminNavbar;